import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';
import { format } from 'date-fns'
import { AnimatePresence } from "framer-motion"

import { Button, Animation } from 'components'
import { ProfileImage, LogoutDialogue } from 'features'
import NameInput from './NameInput'
import EmailInput from './EmailInput'
import SignOutInput from './SignOutInput'
import PasswordInput from './PasswordInput'

import { Data } from 'schema'
import * as actionCreators from 'store/actions'

const defaultStyle = {
    maxWidth: null
}

const Container = styled.div`
    display: grid;
    row-gap: 1rem;
    grid-template-columns: auto;
    grid-template-rows: auto 1fr;
    max-width: ${props => props.styles.maxWidth};
    /* grid-template-columns: auto 1fr;
    grid-gap: 1rem;
    align-items: start;
    @media (max-width: 600px) {
        row-gap: 1rem;
        grid-template-columns: auto;
        grid-template-rows: auto 1fr;
    } */
`

const LeftContainer = styled.div`
    display: flex;
    grid-template-columns: 100%;
    /* grid-template-rows: 1fr auto auto; */
    grid-gap: 0.5rem;
    flex-direction: column;
    justify-items: flex-start;
    align-items: center;
`

const StatsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const StatsValue = styled.div`
    font-weight: bolder;
    font-size: 0.9rem;
`

const StatsLabel = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 0.7rem;
    width: 3rem;
    color: var(--text-color);
    margin-top: 0.2rem;
`

const RightContainer = styled.div`
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto auto auto auto;
    border-radius: 5px;
`

const Title = styled.div`
    font-size: 0.8rem;
    font-weight: bolder;
    text-transform: uppercase;
    margin-bottom: 0.2rem;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
`

const Cell = styled.div`
    padding: 1rem;
    border-style: solid;
    border-color: var(--primary-accent-color);
    border-width: ${props => props.borderWidth || '2px'};
    border-radius: ${props => props.borderRadius};
    display: flex;
    flex-direction: column;
    align-items: space-around;
    cursor: ${props => props.cursor};
    overflow: hidden;
`

const Input = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
`

const Success = styled.div`
    margin-top: 0.2rem;
    font-size: 0.8rem;
    color: var(--success-color);
`

const ProviderIcon = styled.div`
    background-color: ${props => props.provider === 'google.com' ? '#DB4437'
                                : props.provider === 'facebook.com' ? '#3b5998'
                                : 'var(--focus-color)'};
    border-radius: 5px;
    padding: 0.2rem 1rem;
    color: #fff;
    font-size: 0.8rem;
    font-weight: bolder;
    line-height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 0.2rem 0;
`

const Text = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 1200px) {
        max-width: 15rem;
    }
`

class ProfileTab extends Component {
    constructor(props){
        super(props);

        // Account stats
        this.joinedDate = `Joined ${format(new Date(this.props.user['created']), 'd MMM yyyy').toString()}`
        // const data = new Data(this.props.data)
        // const dataStats = data.getStats()['stats']
        const dataStats = {
            'Created': this.props.created,
            'Completed': this.props.completed,
            'In progress': this.props.incomplete
        }

        let statsBlocks = []
        for (const [key, value] of Object.entries(dataStats)) {
            statsBlocks.push(
                <StatsContainer>
                    <StatsValue>{value || '-'}</StatsValue>
                    <StatsLabel>{key === 'Created' ? 'Items created' : 'Items completed'}</StatsLabel>
                </StatsContainer>
            )
        }
        // statsBlocks.splice(1,0,<Divider/>)
        statsBlocks.pop()
        statsBlocks.unshift(
            <StatsContainer>
                <StatsValue>{Object.keys(this.props.data['pages']).length}</StatsValue>
                <StatsLabel>Pages created</StatsLabel>
            </StatsContainer>
        )
        this.stats = statsBlocks

        // Button styles
        this.buttonStyle = {
            border: '1px solid var(--secondary-color)', 
            backgroundColor: 'var(--primary-color)', 
            width:'fit-content', 
            margin: '0'
        }

        this.signOutStyle = {
            border: '1px solid var(--secondary-color)', 
            backgroundColor: 'var(--secondary-color)', 
            width:'fit-content', 
            margin: '0'
        }

        this.editStyle = {
            // color: 'var(--primary-color)',
            margin: 0,
            width: 'fit-content',
            border: '1px solid transparent',
            backgroundColor: 'var(--focus-color)',
            color: 'white'
        }

        this.styles = Object.assign({}, defaultStyle, this.props.styles)

        // State
        this.state = {
            edit: null,
            first_name: this.props.user['first_name'],
            last_name: this.props.user['last_name'],
            email: this.props.user['email'],
            img: this.props.user['picture'],
            password: true, // Find out how to determine if got password
            error: null,
            message: {email: null, password: null}
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.success && this.props.success['password']){
            this.props.success['password'] === '*Password has been updated' & this.props.secModalID !== 'LogoutDialogue' && this.props.setSecModal(<LogoutDialogue message='Please login again with your new password'/>, 'LogoutDialogue')
        }

    }

    imgHandler = (url) => {
        const oldUser = {...this.props.user}
        let updatedUser = {...this.props.user}
        updatedUser['picture'] = url
        this.props.updateUser(updatedUser, oldUser)
    }

    passwordHandler = (value, type) => {
        // this.setState({edit: null})
        console.log('Pasword handler', value, type )
        if(type === 'CHANGE_PASSWORD'){
            this.props.updatePassword(value['old'], value['new'],this.props.user['email'])
        } else if(type === 'RESET_PASSWORD'){
            this.props.resetPassword(this.props.user['email'])
        }
    }

    nameHandler = (first,last) => {
        this.setState({
            first_name: first, 
            last_name: last, 
            edit: null
        })

        if(first !== this.props.user['first_name'] || last !== this.props.user['last_name']){
            let updatedUser = {...this.props.user}
            updatedUser['first_name'] = first
            updatedUser['last_name'] = last
            this.props.updateUser(updatedUser)
        }
    }

    emailHandler = (email) => {
        this.props.updateEmail(this.props.user, email)
    }

    resetHandler = () => {
        this.props.authReset()
        this.setState({
            edit: null,
            error: null,
            message: {email: null, password: null}
        })
    }

    changeTab = (tab) => {
        this.props.authReset()
        this.setState({
            edit: tab,
            error: null,
            message: {email: null, password: null}
        })
    }

    render() {
        const provider = this.props.user['provider']
        const thirdParty = ['google.com', 'facebook.com'].includes(provider)
        return (
            <Container styles={this.styles}>
                <LeftContainer>
                    <ProfileImage img={this.props.user['picture']} style={{size: '8rem'}} onSelect={this.imgHandler} />
                    <Title style={{textAlign:'center'}}>{this.joinedDate}</Title>
                    <Subtitle style={{display: 'grid', gridTemplateColumns: '30% 30% 30%', gridGap: '0.5rem'}}>{this.stats}</Subtitle>
                </LeftContainer>

                <RightContainer>

                    {/* Email */}
                    <Cell borderRadius='5px 5px 0 0' 
                        // cursor={!thirdParty && 'pointer'} 
                        // onClick={() => this.state.edit !== 'EMAIL' & !thirdParty && this.setState({edit: this.state.password && 'EMAIL', error: !this.state.password && '*Please create a password first to continue'})}
                        >
                        <Title>Signed with</Title>
                        <AnimatePresence>
                            {this.state.edit !== 'EMAIL' | (this.state.edit === 'EMAIL' & this.state.error) ? 
                            <Input>
                                <div style={{display: 'flex', flexDirection:'column', alignItems: 'flex-start'}}>
                                    <ProviderIcon provider={provider}>
                                        {provider === 'google.com' ? 'Google'
                                        : provider === 'facebook.com' ? 'Facebook'
                                        : 'Email'}
                                    </ProviderIcon>
                                    <Text>{this.state.email}</Text>
                                </div>
                                {/* {!thirdParty && <Button text='Edit' onSelect={() => this.setState({edit: this.state.password && 'EMAIL', error: !this.state.password && '*Please create a password first to continue'})} styles={this.editStyle}/>} */}
                            </Input>
                            : <Animation animation='expand'>
                                <EmailInput email={this.state.email}
                                    onCancel={this.resetHandler} 
                                    onSubmit={this.emailHandler}/>
                            </Animation>}
                        </AnimatePresence>
                        {this.state.error && <Error>{this.state.error}</Error>}
                        {this.props.success && this.props.success['email'] && <Success>{this.props.success['email']}</Success>}
                        {this.props.error && this.props.error['email'] && <Error>{this.props.error['email']}</Error>}
                    </Cell>

                    {/* Name */}
                    <Cell cursor='pointer' onClick={() => this.state.edit !== 'NAME' && this.changeTab('NAME')} borderWidth='0 2px 2px 2px'>
                        <Title>Name</Title>
                        <AnimatePresence>
                            {this.state.edit !== 'NAME' ? 
                            <Input>
                                {`${this.state.first_name} ${this.state.last_name || ''}`}
                                <Button text='Edit' onSelect={() => this.changeTab('NAME')} styles={this.editStyle}/>
                            </Input>
                            : <Animation animation='expand'>
                                <NameInput first_name={this.state.first_name} last_name={this.state.last_name}
                                    onCancel={this.resetHandler} 
                                    onSubmit={this.nameHandler}/>
                            </Animation>}
                        </AnimatePresence>
                    </Cell>

                    

                    {/* Password */}
                    {!thirdParty &&
                    <Cell borderWidth='0 2px 2px 2px'>
                        <Title>Password</Title>
                        <Subtitle>If you signed up via a third-party provider, you may set a password to login via email and password</Subtitle>
                        {!this.state.password ? <Button text='Create password' styles={this.buttonStyle} onSelect={() => this.changeTab('CHANGE_PASSWORD')}/>
                        : <div style={{display: 'flex', marginBottom: '0.5rem'}}>
                            {/* <Button text='Change password' styles={Object.assign(this.buttonStyle, {margin: '0 0.5rem 0 0'})} onSelect={() => this.changeTab('CHANGE_PASSWORD')}/> */}
                            <Button text='Update password' styles={{...this.buttonStyle, backgroundColor: 'var(--secondary-color)'}} onSelect={() => this.changeTab('RESET_PASSWORD')}/>    
                        </div>}
                        
                        <AnimatePresence>
                            {['CREATE_PASSWORD', 'CHANGE_PASSWORD', 'RESET_PASSWORD'].includes(this.state.edit) && 
                            <Animation animation='expand'>
                                <PasswordInput type={this.state.edit} userEmail={this.props.user['email']}
                                    onCancel={this.resetHandler}
                                    onSubmit={this.passwordHandler}
                                    success={this.props.success && this.props.success['password']}
                                    error={this.props.error && this.props.error['password']}
                                    />
                            </Animation>}
                        </AnimatePresence>

                    </Cell>}

                    {/* Sign out */}
                    <Cell borderWidth='0 2px 2px 2px' borderRadius='0 0 5px 5px'>
                        <Title>Sign out</Title>
                        <Subtitle>End your current session and sign out of your account</Subtitle>
                        <Button text='Sign out' styles={this.signOutStyle} onSelect={() => this.changeTab('SIGN_OUT')}/>
                        <AnimatePresence>
                            {this.state.edit === 'SIGN_OUT' && 
                            <Animation animation='expand'>
                                <SignOutInput onSignOut={() => this.props.signOutApp()}
                                onCancel={() => this.setState({edit: null, error: null})}/>
                            </Animation>}
                        </AnimatePresence>
                    </Cell>
                </RightContainer>
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        error: state.auth.error,
        success: state.auth.success,
        secModalID: state.content.secModalID,

        created: state.auth.created,
        completed: state.auth.completed,
        incomplete: state.auth.incomplete
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setSecModal: (element, id) => dispatch(actionCreators.setSecModal(element,id)),
        updateUser: (user, oldUser) => dispatch(actionCreators.updateUser(user, oldUser)),
        updateEmail: (user, email) => dispatch(actionCreators.updateEmail(user, email)),
        signOutApp: () => dispatch(actionCreators.signOutApp()),
        resetPassword: (email) => dispatch(actionCreators.resetPassword(email)),
        updatePassword: (oldPassword, newPassword, email) => dispatch(actionCreators.updatePassword(oldPassword, newPassword, email)),
        authReset: () => dispatch(actionCreators.authReset())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileTab);
